<template>
    <!-- FOOTER -->
    <div id="footer">
    <span id="options" target="Options">OPT</span>
    </div>
    <!-- END OF FOOTER -->
</template>



<script>

export default {
  
   mounted(){

    this.setBtn(document.getElementById("options"));
   },

    methods:{

      animation:function(e){ 
        this.stopPropagation(e); 
        e.target.style.animationName = 'flicker';

        this.switchTheme();
        
      },
      switchTheme:function(){

        switch(this.colorTheme){
          case "red": document.getElementById("colorTheme").setAttribute("href","/static/css/Terminal_Blue.css");
                      this.colorTheme="blue";localStorage.colorTheme=this.colorTheme;break;

          case "green": document.getElementById("colorTheme").setAttribute("href","/static/css/Terminal_Red.css");
                        this.colorTheme="red";localStorage.colorTheme=this.colorTheme;break;

          case "blue": document.getElementById("colorTheme").setAttribute("href","/static/css/Terminal_Green.css");
                       this.colorTheme="green";localStorage.colorTheme=this.colorTheme;break;
        }

      },
      setBtn:function(btn){
          
          var parent=this;

            if(this.isMobile){btn.addEventListener("touchstart",this.animation,false);}
            else{btn.addEventListener("mousedown",this.animation,false);}
              
              btn.addEventListener('animationend', function(e){
                e.target.style.animationName = '';
                //parent.$router.push({ name:e.target.getAttribute("target") });
              }, false);
              
            }
            
}
//end of methods

}

</script>



// WEBPACK FOOTER //
// Footer.vue?269b4409